import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@api/client';
import type { ChatCapabilitiesRegistry } from '../../types/chat';

/**
 * Fetches the backend-owned chat contract, including the platform-card
 * catalogue. The catalogue is plan- and permission-scoped, so it is the
 * authoritative list of card types the current user can receive.
 */
export function useChatCapabilities(enabled: boolean = false) {
  return useQuery<ChatCapabilitiesRegistry>({
    queryKey: ['chat-capabilities'],
    queryFn: async () => {
      const { data } = await apiClient.get<ChatCapabilitiesRegistry>('/chat/capabilities');
      return data;
    },
    enabled,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}
